import { useEffect, useState } from "react";

// Rupee-with-decimals input. Accepts free-form typing (digits, dots, commas)
// and reports back the value in cents. Displays the value formatted with
// thousand-separators when the field isn't focused so users see "100,000.00"
// instead of "10000000".
export function RupeeInput({
  cents,
  onChange,
  placeholder = "0.00",
}: {
  cents: number;
  onChange: (cents: number) => void;
  placeholder?: string;
}) {
  const [focused, setFocused] = useState(false);
  const [raw, setRaw] = useState<string>("");

  // Fix #22: re-sync `raw` whenever `cents` changes externally (e.g. after a
  // refetch) while the field isn't focused. Without this, the next focus would
  // show the previous text instead of the latest value.
  useEffect(() => {
    if (!focused) setRaw(cents ? (cents / 100).toString() : "");
  }, [cents, focused]);

  const display = focused
    ? raw
    : cents
      ? (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : "";

  function commit(text: string) {
    const cleaned = text.replace(/,/g, "").replace(/[^0-9.]/g, "");
    const dotCount = (cleaned.match(/\./g) ?? []).length;
    if (dotCount > 1) return;
    const rupees = parseFloat(cleaned || "0");
    if (Number.isNaN(rupees)) return;
    onChange(Math.round(rupees * 100));
  }

  return (
    <input
      className="form-input num"
      inputMode="decimal"
      value={display}
      onFocus={() => {
        setFocused(true);
        setRaw(cents ? (cents / 100).toString() : "");
      }}
      onBlur={() => setFocused(false)}
      onChange={(e) => {
        setRaw(e.target.value);
        commit(e.target.value);
      }}
      placeholder={placeholder}
    />
  );
}
